// extracted by mini-css-extract-plugin
export default {"flex":"Modal_flex__bgh2f","form":"Modal_form__FF7+E","row":"Modal_row__wEII1","stack":"Modal_stack__+ixND"};